import {IntermediatePart} from "../../parts/intermediatePart";
import {Vanity} from "../../parts/vanity";
import {NotQCVanityDoorStylesFilters} from "../../constants";
import store from "../../../../../store";

export default class Mirror extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_mirror';
    this.partName = 'Mirror';
    this.translateId = "visualizer.bathroom.vanity.vanity_mirror";
    this.homePageTitle = 'Mirrors';
    this.visible = [Vanity.Types.Complete, Vanity.Types.Custom];
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Mirror())
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    let navItems = super.navigationSubItemsWithFilter('Pedestal', this.getParent().counterTopSize(), filteredAvailableFeatures);
    // console.log('navItems1', navItems.slice());
    const vanityParent = this.getParent();
    const vanityPart = (vanityParent.activeSubType_ === Vanity.Types.Custom)
      ? vanityParent.pedestalSink
      : vanityParent.completeVanity;
    /*** return Mirrors with the same Color and DoorStyle or Material - as the current selected Vanity ***/
    if (vanityPart && vanityPart.activeFeature && vanityPart.activeFeature.dbFeature && vanityPart.activeFeature.dbFeature.filterValueIDs) {
      const oldVanityType = NotQCVanityDoorStylesFilters.some(filterName => {
        const partName = vanityPart.activeFeature.partName;
        return partName.includes(filterName) && !partName.includes("QC");
      });
      const filterGroups = store.getState().filterState.filterGroups;
      const colorFilter = filterGroups.find(group => group.name === "Color");
      const activeFilterValueIDs = vanityPart.activeFeature.dbFeature.filterValueIDs;
      const secondFilter = filterGroups.find(group => group.name === (oldVanityType ? "Material" : "DoorStyle"));

      if (colorFilter && secondFilter) {
        navItems = navItems.map(item => {
          item.mathesToCurrentVanity = IntermediatePart.featureHasFilters(item.part, activeFilterValueIDs, colorFilter, secondFilter);
          return item
        }).sort((itemA, itemB) => {
          return (itemA.mathesToCurrentVanity < itemB.mathesToCurrentVanity)
            ? 1
            : ((itemB.mathesToCurrentVanity < itemA.mathesToCurrentVanity)
              ? -1
              : 0)
        });
      }

      // console.log('sorted!', navItems);
    }
    return navItems
  }

  setDefault(layout) {
    const counterTopSize = this.getParent().counterTopSize();
    const filteredFeatures = this.features && this.features.filter(f => f.matchesMetaForCondition('Pedestal', counterTopSize)) || [];

    let name = null;
    if (this.activeFeature) {
      name = this.activeFeature.partName
    }
    if (name) {
      name = name.split(" Single")[0].split(" Double")[0].split(" S")[0].split(" D")[0]
    }

    if (!this.tryToSetTheSameFeatureByFilters(filteredFeatures) && !this.tryToSetTheSameFeature(filteredFeatures, name || null)) {
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Elegant BLK");
      });
      this.activeFeature = hardCodedDefault || super.setDefault(layout) || filteredFeatures[0];
      this.setPlaceholderFeature(filteredFeatures, layout);
    }
  }

  tryToSetTheSameFeatureByFilters(filteredFeatures, layout) {
    const vanityParent = this.getParent();
    const vanityPart = (vanityParent.activeSubType_ === Vanity.Types.Custom)
      ? vanityParent.pedestalSink
      : vanityParent.completeVanity;
    if (vanityPart && vanityPart.activeFeature && !vanityPart.activeFeature.partName.includes("WizardPlaceholder")
      && vanityPart.activeFeature.dbFeature && vanityPart.activeFeature.dbFeature.filterValueIDs) {
      const vanityFilters = vanityPart.activeFeature.dbFeature.filterValueIDs;
      const filterGroups = store.getState().filterState.filterGroups;
      const materialFilter = filterGroups.find(group => group.name === "Material");
      const colorFilter = filterGroups.find(group => group.name === "Color");

      const matchingFilterFeature = filteredFeatures.find((feature) => {
        return feature.dbFeature && materialFilter && colorFilter
          && feature.dbFeature.filterValueIDs[materialFilter.id]
          && vanityFilters[materialFilter.id]
          && vanityFilters[colorFilter.id]
          && feature.dbFeature.filterValueIDs[materialFilter.id].includes(vanityFilters[materialFilter.id][0])
          && feature.dbFeature.filterValueIDs[colorFilter.id]
          && feature.dbFeature.filterValueIDs[colorFilter.id].includes(vanityFilters[colorFilter.id][0])
      });
      if (matchingFilterFeature) {
        this.activeFeature = matchingFilterFeature;
        this.setPlaceholderFeature(filteredFeatures, layout);
        return true
      }
    }
    return false
  }

  tryToSetTheSameFeature(filteredFeatures, partName, placeholderName) {
    if (this.activeFeature && this.activeFeature.partName) {
      const nameSplitted = (partName || this.activeFeature.partName).split(" FM")[0];
      this.activeFeature = filteredFeatures.find(feature => {
        const currentNameSplitted = feature.partName.split(" FM")[0];
        return nameSplitted === currentNameSplitted
      });
      // console.log('AF', filteredFeatures, this.activeFeature);
      this.placeholderFeature = filteredFeatures.find((feature) => {
        return placeholderName
          ? feature.dbFeature.displayName && feature.dbFeature.displayName.includesCI("placeholder")
          && feature.dbFeature.displayName.includes(placeholderName)
          : feature.dbFeature.displayName && feature.dbFeature.displayName.includesCI("placeholder")
      });
      if (this.activeFeature) {
        return true
      }
    }
    return false
  }

  setPlaceholderFeature(filteredFeatures, layout) {
    const placeholderDefault = filteredFeatures.find((feature) => {
      return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
    });
    this.placeholderFeature = placeholderDefault || super.setDefault(layout) || null;
  }

  setLayers(layout) {
    const counterTopSize = this.getParent().counterTopSize();
    if (this.activeFeature && (this.activeFeature.matchesMetaForCondition('Pedestal', counterTopSize)
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }
    this.setDefault(layout);
    return super.setLayers(layout);
  }

  setZIndex(zIndexes) {
    // if ((this.getParent().activeSubType_ === Vanity.Types.Custom) && this.activeFeature) {
    if (zIndexes && this.activeFeature) {
      // this.activeFeature.layer.zIndex = Z.layouts.Large.Vanity.Custom.Mirror;
      this.activeFeature.layer.zIndex = zIndexes.Vanity.Custom.Mirror;
    }
    if(zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndexes.Vanity.Custom.Mirror;
    }
  }
}
